import { useState, useEffect } from "react";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";

import Layout from "../Layout";
import { PlusMinusButton } from "../../components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import './Checkout.css';
import { InputText, TextArea, Switch } from "../../components/Input";

export default function Checkout() {
    const history = useHistory();
    const { local_id } = useParams();
    const [ basketItems, setBasketItems ] = useState();
    const [ localData, setLocalData] = useState();
    const [ shippingEnable, setShippingEnable ]= useState(false);
    const [ errorMessage, setErrorMessage ] = useState('');

    useEffect(() => {
        try{
            setBasketItems(JSON.parse(localStorage.getItem('orden')));
            setLocalData(JSON.parse(localStorage.getItem('localData')));
        }

        catch(error){
            alert("Error");
        }

    }, []);

    const changeCounter = (id, change_type) => setBasketItems(basketItems.map( item => {
            if(item.id === id){
                return {
                    ...item,
                    cantidad: change_type === 'INCREASE' ? (item.cantidad < 50 ? item.cantidad + 1 : item.cantidad) : ( item.cantidad > 0 ? item.cantidad -1 : item.cantidad)
                }
            }
            
            return item;
        })
    );

    const getTotal = () => {
        let sum = 0;
        if(basketItems){
            basketItems.map( item => sum += item.precio * item.cantidad);
        }
        return sum;
    }

    const removeItem = id =>{
        setBasketItems(basketItems.filter( item => item.id !== id ));
    }

    const goBack = () => {
        window.scrollTo(0, 0);
        history.push('/menu/'+local_id);
    }

    const generateWhatsappMessage = evt => {
        evt.preventDefault();
        setErrorMessage('');
        let special_order = evt.target.preferencias.value;
        let local_number = localData.datos_contacto.telefono;
        let greetings = 'Hola. Me gustaria ordenar lo siguiente:\n\n';
        let total = 0;

        let mesa = null;

        if(localStorage.mesa){
            mesa = "Mesa: *#" + localStorage.getItem("mesa") + "*\n";
        }

        let final_string = mesa + greetings + basketItems.map( item => {
            total += item.precio * item.cantidad;
            return `${item.nombre} *x ${item.cantidad}* = *$${item.precio * item.cantidad}*`
        }).join('\n');

        if(special_order.length > 0){
            if(special_order.trim().length > 0)
                final_string += `\n\nOrden especial: *${special_order}*`;
        }

        if(localData.realiza_envios && shippingEnable){
            let receives_name = evt.target.nombre.value;
            let address = evt.target.domicilio.value;
            if(receives_name.length > 0 && address.length > 0){
                final_string += `\n\nFavor de enviar al domicilio: *${address}*\nRecibe: *${receives_name}*`
            }
            else{
                // alert('Error favor de completar campos de envio, o desactivar el envio');
                setErrorMessage('Error. Favor de completar los campos del envío o desactivar esta opción');
                return null;
            }
        }

        final_string += `\n\nEl total es de: *$${total}*`;
        final_string = encodeURIComponent(final_string);
        
        console.log(final_string);

        let link = `https://wa.me/521${local_number}?text=`+final_string;
        window.open(link);
    }

    const changeShippingStatus = evt => {
        setShippingEnable(evt.target.checked);
        if(!evt.target.checked && errorMessage.length > 0){
            setErrorMessage('');
        }
    }

    return(
        <Layout local={ local_id }>
            <h2 className='restaurant__name' style={ {marginTop: '20px'} }>Detalle de orden</h2>

            <div className='basket'>
                {
                    basketItems && localData ? 
                    basketItems.map( (basketItem, index) => {
                        return <div key={ index }><div className='basket__item'>
                            <div className='basket__item__item-image' style={ 
                                {
                                    backgroundImage: `url(${basketItem.url_img})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    borderRadius: '20px'
                                } 
                            }></div>

                            <div className='basket__item__data'>
                                <h5>{ basketItem.nombre }</h5>
                                <h6>$ { basketItem.precio }</h6>
                                <div className='basket__item__buttons'>
                                    <PlusMinusButton 
                                        small={ true }
                                        counter={ basketItem.cantidad }
                                        handleOnClickMinus = { () => changeCounter( basketItem.id, 'DECREASE')} 
                                        handleOnClickPlus = { () => changeCounter( basketItem.id, 'INCREASE')}
                                        />
                                    <span className='basket__item__delete-btn' onClick={ () => removeItem(basketItem.id) }><FontAwesomeIcon icon={ faTrash } size='lg'/></span>
                                </div>
                            </div>
                        </div>

                        </div>
                    })
                : null }

                    <div className='basket__prices'>
                        <div className='basket__params'>
                            <h5>Subtotal</h5>
                            <h5>Envio</h5>
                            <h3>Total</h3>
                        </div>

                        <div className='basket__numbers'>
                            <h5>$ { getTotal() }</h5>
                            <h5>$ 0.00</h5>
                            <h3>$ { getTotal() }</h3>
                        </div>
                        
                    </div>

                    <div className='additional__data'>
                        <form onSubmit={ generateWhatsappMessage }>
                            <TextArea name='preferencias' label='Orden especial' placeholder='Ej. Sin cebolla' />
                            { localData ? localData.realiza_envios ? 
                            <div className='send-home'>
                                <h5 style={ {marginBottom: 10} }>Enviar a domicilio</h5>
                                <Switch name='hacer_envio' onChange={ changeShippingStatus } />
                            </div>

                            : null : null }
                            
                            { shippingEnable ?
                            <> 
                                { /* <h5 style={ {marginTop: '20px'} }>Datos adicionales</h5> */ }

                                <InputText name='nombre' placeholder='Nombre' />
                                <InputText name='domicilio' placeholder='Domicilio' />
                            </>
                            : null }

                            { errorMessage ? <p className='error-message'>{ errorMessage }</p>: null }

                            <button type='submit' className='whatsapp-button button__flat button__full-width button__green' style={ {marginTop: 30} } ><FontAwesomeIcon icon={ faWhatsapp } size='lg'/> ORDENAR</button>
                            <button type='button' className='back-button button__flat button__full-width button__white' onClick={ goBack }><FontAwesomeIcon icon={ faArrowLeft } size='lg'/> REGRESAR</button>

                        </form>
                    </div>
            </div>
        </Layout>
    );
}